import { render, staticRenderFns } from "./CargarVideoTeacher.vue?vue&type=template&id=4bc76e47&scoped=true"
import script from "./CargarVideoTeacher.vue?vue&type=script&lang=js"
export * from "./CargarVideoTeacher.vue?vue&type=script&lang=js"
import style0 from "./CargarVideoTeacher.vue?vue&type=style&index=0&id=4bc76e47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc76e47",
  null
  
)

export default component.exports